// Espelha a coluna tipoCliente das tabelas clientes e clientesErp.
export const TIPO_CLIENTE_PJ = 0;
export const TIPO_CLIENTE_PF = 1;

// A coluna tem default 0 no banco, então qualquer coisa que não seja
// explicitamente PF conta como PJ.
export function tipoClienteDe(cliente) {
  return cliente?.tipoCliente === TIPO_CLIENTE_PF
    ? TIPO_CLIENTE_PF
    : TIPO_CLIENTE_PJ;
}

export function ehPessoaFisica(cliente) {
  return tipoClienteDe(cliente) === TIPO_CLIENTE_PF;
}

export function siglaTipoCliente(cliente) {
  return ehPessoaFisica(cliente) ? "PF" : "PJ";
}

export function rotuloTipoCliente(cliente) {
  return ehPessoaFisica(cliente) ? "Pessoa física" : "Pessoa jurídica";
}

export const OPCOES_TIPO_CLIENTE = [
  { valor: TIPO_CLIENTE_PJ, sigla: "PJ", rotulo: "Pessoa jurídica" },
  { valor: TIPO_CLIENTE_PF, sigla: "PF", rotulo: "Pessoa física" },
];
